<template>
  <UiBackdrop :is-open="isOpen" :close="close" />

  <SfModal
    :id="`modal-${id}-container`"
    :data-testid="`modal-${id}-container`"
    :model-value="isOpen"
    class="z-20"
    tag="section"
    role="alertdialog"
    @update:model-value="toggle?.($event)"
  >
    <header class="flex flex-col">
      <UiIconButton
        :id="`modal-${id}-close`"
        :icon="IconClose"
        variant="secondary"
        class="absolute right-2 top-2"
        @click="close"
      />
      <UiHeading type="h2" class="mt-2">
        {{ title }}
      </UiHeading>
    </header>
    <div class="my-4"><slot /></div>
    <footer
      class="mt-8 flex gap-4"
      :class="[
        { 'flex-row justify-end': buttonDisplay === 'row-right' },
        { 'flex-row': buttonDisplay === 'row-full' },
        { 'flex-col-reverse justify-end': buttonDisplay === 'col' },
      ]"
    >
      <UiButton
        :id="`modal-${id}-cancel`"
        variant="secondary"
        :disabled="cancelDisabled"
        :class="[{ 'w-full': buttonDisplay === 'row-full' }]"
        @click="cancelClick"
      >
        {{ cancelLabel }}
      </UiButton>
      <UiButton
        :id="`modal-${id}-confirm`"
        :disabled="confirmDisabled"
        :loading="confirmIsLoading"
        :class="[{ 'w-full': buttonDisplay === 'row-full' }]"
        @click="!confirmIsLoading && confirmClick()"
      >
        {{ confirmLabel }}
      </UiButton>
    </footer>
  </SfModal>
</template>

<script setup lang="ts">
import { IconClose } from '#components';

import type { ModalProps } from '~/components/ui/Modal/types';

withDefaults(defineProps<ModalProps>(), { buttonDisplay: 'row-full' });
</script>
